module.exports = __webpack_public_path__ + "static/media/S (115).8ac8e578.jpg";